import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommentPipe } from 'src/app/components/auth/page-login-img/comment-safe.pipe';



@NgModule({
  declarations: [CommentPipe],
  imports: [
    CommonModule
  ],
  exports: [CommentPipe]
})
export class SharedModule { }
